var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('myheader'),_c('div',{staticClass:"usermain"},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.content)}})])]),_c('myfooter'),_c('myright')],1)}
var staticRenderFns = []

export { render, staticRenderFns }